import { Component, Input, OnChanges } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration } from 'chart.js';
import { CampaignMessageBreakDown } from '../../../../../pages/organization/campaigns/types/campaignDetails';
import { ThemedChart } from '../themed-chart';
import { barChartHeight, formatPercent, shareBarConfig } from '../chart-theme';

/** Delivery rate per campaign message: ink bars on the track colour. */
@Component({
  selector: 'app-engagement-breakdown-by-messages-graph',
  standalone: true,
  imports: [BaseChartDirective],
  templateUrl: './engagement-breakdown-by-messages-graph.component.html',
  styleUrl: '../report-graph.css',
})
export class EngagementBreakdownByMessagesGraphComponent extends ThemedChart implements OnChanges {
  @Input() graphData: CampaignMessageBreakDown[] | null = [];

  rows: CampaignMessageBreakDown[] = [];
  chartData: ChartConfiguration<'bar'>['data'] = { labels: [], datasets: [] };
  chartOptions: ChartConfiguration<'bar'>['options'] = {};
  height = barChartHeight(2);

  ngOnChanges() {
    this.rows = (Array.isArray(this.graphData) ? this.graphData : [])
      .filter((row) => !!row)
      .map((row) => ({ ...row, deliveryRate: Number(row.deliveryRate) || 0 }));
    this.redraw();
  }

  protected render() {
    const labels = this.rows.map((row) => row.message || 'Untitled message');
    const values = this.rows.map((row) => row.deliveryRate);
    const { data, options } = shareBarConfig(this.tokens, labels, values, (_index, value) =>
      `${formatPercent(value)} delivered`
    );
    this.chartData = data;
    this.chartOptions = options;
    this.height = barChartHeight(this.rows.length);
  }
}
